module.exports = __webpack_public_path__ + "static/img/planning4.e3342e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/planning4.png
// module id = +L1F
// module chunks = 1